import * as actions from '../../ActionsConst';
import helpers from './Helpers';

const productSettingsTemplates = (state = [], action) => {
  switch (action.type) {
    case actions.RECEIVE_PRODUCT_TEMPLATES:
      return helpers.receiveProductTemplates(state, action);
    default:
      return state;
  }
};

export default productSettingsTemplates;
